import Util from '@/util'

const FormConstants = Object.freeze({
  Form: {
    COLUMNS: [{
      name: 'name',
      type: 'input',
      label: 'First Name',
      class: 'is-4'
    }, {
      name: 'lname',
      type: 'input',
      label: 'Last Name',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'title',
      type: 'input',
      label: 'Title',
      class: 'is-4'
    }, {
      name: 'email',
      type: 'input',
      label: 'Email',
      class: 'is-4'
    }, {
      name: 'phone',
      type: 'input',
      label: 'Phone',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'organization',
      type: 'input',
      label: 'Organization',
      class: 'is-8'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'topicsHeader',
      type: 'header',
      headerType: 'h4',
      label: 'Check applicable topic(s) of your inquiry',
      class: 'is-12'
    }, {
      name: 'checkboxes',
      type: 'checkbox',
      noGap: true,
      label: 'Test Checkbox',
      class: 'is-12'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'message',
      type: 'input',
      inputType: 'textarea',
      placeholder: '',
      autoSize: { minRows: 4 },
      maxlength: 1000,
      showWordLimit: true,
      label: 'Message',
      class: 'is-12'
    }],

    KEYS_CHECKBOX: [
      { key: 'Braille Transcription' },
      { key: 'Blind and Visually Impaired' },
      { key: 'Orientation and Mobility' },
      { key: 'Deaf-Blindness' },
      { key: 'Deaf and Hard of Hearing' },
      { key: 'Audiology' },
      { key: 'Sign-Language Interpreting' },
      { key: 'Occupational Therapy' },
      { key: 'Physical Therapy' },
      { key: 'Speech and Language Pathology' },
      { key: 'School Psychology' },
      { key: 'On-Site Services' },
      { key: 'Remote Services' },
      { key: 'Hybrid Services (On-site and Remote)' },
      { key: 'Other' },
    ],

    getValidators: (instance, params = {}) => {
      let validators = {
        name: [{ required: true, trigger: 'blur', message: 'Required' }],
        lname: [{ required: true, trigger: 'blur', message: 'Required' }],
        title: [{ required: false, trigger: 'blur', message: 'Required' }],
        email: [
          { required: true, trigger: 'blur', message: 'Required' },
          { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
        ],
        phone: [
          { required: true, trigger: 'blur', message: 'Required' },
          { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
        ],
        organization: [{ required: false, trigger: 'blur', message: 'Required' }],
        // checkboxes: [{ required: true, trigger: 'blur', message: 'Required' }],
        message: [{ required: true, trigger: 'blur', message: 'Required' }],
      }
      return validators
    },

    KEYS: [
      { key: 'name', type: 'string', default: undefined },
      { key: 'lname', type: 'string', default: undefined },
      { key: 'title', type: 'string', default: undefined },
      { key: 'email', type: 'string', default: undefined },
      { key: 'phone', type: 'string', default: undefined },
      { key: 'organization', type: 'string', default: undefined, alias: 'company' },
      // { key: 'checkboxes', type: 'string', default: undefined },
      { key: 'message', type: 'string', default: undefined },
    ]
  },
})

export default FormConstants
